import axios from 'axios';
import { Envelope } from '../interfaces/envelope';
import { PostPutSubscriptionsUnsigned, SubscriptionsUnsigned } from '../interfaces/notifications';

async function getSubscriptionsUnsigned(): Promise<SubscriptionsUnsigned[]> {
	try {
		const response = await axios.get<Envelope<SubscriptionsUnsigned[]>>(
			`notifications/subscriptionsUnsigned`
		);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

async function postSubscriptionsUnsigned(
	subscriber: PostPutSubscriptionsUnsigned
): Promise<SubscriptionsUnsigned[]> {
	try {
		const response = await axios.post<Envelope<SubscriptionsUnsigned[]>>(
			`notifications/subscriptionsUnsigned`,
			subscriber
		);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

async function putSubscriptionsUnsigned(
	id: string,
	subscriber: PostPutSubscriptionsUnsigned
): Promise<SubscriptionsUnsigned[]> {
	try {
		const response = await axios.put<Envelope<SubscriptionsUnsigned[]>>(
			`notifications/subscriptionsUnsigned/${id}`,
			subscriber
		);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

async function deleteSubscriptionsUnsigned(id: string): Promise<null> {
	try {
		const response = await axios.delete<Envelope<null>>(
			`notifications/subscriptionsUnsigned/${id}`
		);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const notifications = {
	getSubscriptionsUnsigned,
	postSubscriptionsUnsigned,
	putSubscriptionsUnsigned,
	deleteSubscriptionsUnsigned,
};
